import { zfUtils } from "./zf_utils";
export class zfcpfst {
    static init() {
        try {
            $(".zfcpfst-hotspot-item").each(function (c) {
                var currentItem = $(this);
                var leftToSeparate = 0;
                var bubbleContainer = currentItem.find(".zfcpfst-hotspot-bubble-container");
                leftToSeparate =
                    bubbleContainer.position().left + bubbleContainer.width() / 2;
                currentItem.css("top", "calc(" +
                    currentItem.data("y") +
                    " - " +
                    currentItem.height() / 2 +
                    "px)");
                currentItem.css("left", "calc(" + currentItem.data("x") + " - " + leftToSeparate + "px)");
            });
        }
        catch (err) {
            console.log("initalization failed: zfcpfst.init() " + err.message);
        }
    }
}
try {
    zfUtils.onReady(zfcpfst.init);
}
catch (err) {
    console.log("initalization failed: zfcpfst.init() " + err.message);
}
